import { Link } from "react-router-dom";
import React from "react";
const Footer = () => { 
    return(
        <>
        <div className="container" style={{marginTop:"200px"}}>
  <footer className="py-3 my-4">
    <ul className="nav justify-content-center border-bottom pb-3 mb-3">
      <li className="nav-item"><Link to="/" className="nav-link px-2 text-body-secondary">Home</Link></li>
      <li className="nav-item"><Link to="/explore" className="nav-link px-2 text-body-secondary">Explore</Link></li>
      <li className="nav-item"><Link to="practiceboard" className="nav-link px-2 text-body-secondary">Practice Board</Link></li>
      <li className="nav-item"><Link to="/scoreboard" className="nav-link px-2 text-body-secondary">Scores</Link></li>
    </ul>
    <p className="text-center text-body-secondary">© 2024 Typeathon, Maria Yasmeen</p>
  </footer>
</div>
        </>
    )

}
export default Footer;